import { render, staticRenderFns } from "./AvaliationItemDashboardCard.vue?vue&type=template&id=5dde3527"
import script from "./AvaliationItemDashboardCard.vue?vue&type=script&lang=js"
export * from "./AvaliationItemDashboardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports